import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";

import { HeaderCell, SortArrow, SortButton } from "./styles";
import { SortableColumnHeaderProps } from "./types";

export const SortableColumnHeader = <Key extends string>({
  column,
  label,
  align = "start",
  width,
  variant = "list",
  sort,
  onSort,
}: SortableColumnHeaderProps<Key>) => {
  const isActive = sort.key === column;
  const directionLabel = sort.dir === "asc" ? "ascending" : "descending";
  const SortIcon =
    sort.dir === "asc" ? ArrowUpwardRoundedIcon : ArrowDownwardRoundedIcon;

  return (
    <HeaderCell
      scope="col"
      $align={align}
      $width={width}
      $variant={variant}
      aria-sort={isActive ? directionLabel : "none"}
    >
      <SortButton
        type="button"
        $align={align}
        $variant={variant}
        onClick={() => onSort(column)}
        aria-label={
          isActive
            ? `Sort by ${label}, currently ${directionLabel}`
            : `Sort by ${label}`
        }
      >
        {label}
        <SortArrow $active={isActive} aria-hidden={true}>
          <SortIcon />
        </SortArrow>
      </SortButton>
    </HeaderCell>
  );
};
